import clsx from 'clsx'
import { mediaQueryDown, mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import type { PropsWithChildren } from 'react'
import styled from 'styled-components'
import { AccommodationIndividualSelectRoomOptionTileCTAContainer } from './AccommodationIndividualSelectRoomOptionTileCTA'
import { AccommodationIndividualSelectRoomOptionTileDetailsContainer } from './AccommodationIndividualSelectRoomOptionTileDetails'
import { AccommodationIndividualSelectRoomOptionTileMessageContainer } from './AccommodationIndividualSelectRoomOptionTileMessage'
import { AccommodationIndividualSelectRoomOptionTilePricingContainer } from './AccommodationIndividualSelectRoomOptionTilePricing'

export const AccommodationPackageTileGrid = styled.div`
  padding: ${rem(16)};
  display: grid;
  gap: ${rem(12)};
  border: 1px solid ${props => props.theme.palette.neutral.default.six};
  grid-template:
    "details details" 1fr
    "pricing cta" auto / 1fr auto;
  
  &:has(${AccommodationIndividualSelectRoomOptionTileMessageContainer}) {
    grid-template:
      "details details" 1fr
      "pricing cta" auto
      "message message" auto / 1fr auto;
  }
  
  &.isSelected {
    ${mediaQueryDown.mobile} {
      border-color: ${props => props.theme.palette.neutral.default.one};
    }

    ${mediaQueryUp.tablet} {
      outline: 1px solid ${props => props.theme.palette.neutral.default.one};
      z-index: 1;
    }
  }

  ${mediaQueryUp.tablet} {
    padding: ${rem(12)};
    border: none;
    &:not(&.isSelected) {
      border-top: 1px solid ${props => props.theme.palette.neutral.default.five};
    }
    grid-template:
      "details pricing" 1fr
      "details cta" auto / 1fr ${rem(250)};

    &:has(${AccommodationIndividualSelectRoomOptionTileMessageContainer}) {
      grid-template:
        "details pricing" 1fr
        "details cta" auto
        "message message" auto / 1fr auto;
    }
  }

  ${mediaQueryUp.desktop} {
    column-gap: ${rem(32)};
    padding: ${rem(16)};
    gap: ${rem(20)} ${rem(32)};
  }

  > ${AccommodationIndividualSelectRoomOptionTileCTAContainer} {
    grid-area: cta;
  }
  > ${AccommodationIndividualSelectRoomOptionTileDetailsContainer} {
    grid-area: details;
  }
  > ${AccommodationIndividualSelectRoomOptionTileMessageContainer} {
    grid-area: message;
  }
  > ${AccommodationIndividualSelectRoomOptionTilePricingContainer} {
    grid-area: pricing;
  }
`

interface Props {
  isSelected?: boolean
}

function AccommodationIndividualSelectRoomOptionTile({ isSelected, children }: PropsWithChildren<Props>) {
  return <AccommodationPackageTileGrid className={clsx({ isSelected })}>
    {children}
  </AccommodationPackageTileGrid>
}

export default AccommodationIndividualSelectRoomOptionTile
